module.exports = __webpack_public_path__ + "img/photo-0049.0fc48145.jpg";